import { useCallback, useContext } from "react";
import { useCancelAbsenceRequests } from "src/Pages/Company/Absences/api/absenceRequests.queries";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";
import __ from "src/utils/Translations";

export const useConfirmCancellation = () => {
  const { setModal, resetModal } = useContext(GlobalModalContext);

  const { mutate: cancelAbsenceRequest, isPending } =
    useCancelAbsenceRequests();

  const confirmCancellation = useCallback(
    (absenceRequestId: string, name: string, eTag: string) => {
      if (typeof setModal === "function") {
        setModal({
          open: true,
          title: <>{__("Czy na pewno chcesz anulować wniosek?")}</>,
          description: __(
            `Po anulowaniu wniosku "${name}" nie będzie możliwości, aby go przywrócić.`
          ),
          actions: [
            {
              label: __("Wyjdź"),
              variant: "outlined",
              loading: isPending,
              callbackFn: () => {
                resetModal();
              },
            },
            {
              label: __("Anuluj wniosek"),
              variant: "contained",
              color: "error",
              loading: isPending,
              callbackFn: () => {
                resetModal();
                cancelAbsenceRequest({ absenceRequestId, eTag });
              },
            },
          ],
        });
      }
    },
    [cancelAbsenceRequest, isPending, resetModal, setModal]
  );

  return { confirmCancellation };
};
